import './index.css'

import React from 'react'
import { hydrateRoot } from 'react-dom/client'
import App from './App'

// Получаем данные из window.__MODX_DATA__
const data = window.__MODX_DATA__ || {}

console.log('Client hydration:', data)

hydrateRoot(
  document.getElementById('himavangard'),
  <App
    data={data}
  />
)